<div class="text-center">
  <!-- face_detector_selection_control -->
  <h5>Select Face Detector</h5>
  <select id="selectFaceDetector" (change)="faceApiService.onSelectedFaceDetectorChanged($event)">
    <option value="ssd_mobilenetv1"
            [selected]="faceApiService.selectedFaceDetector === faceApiService.SSD_MOBILENETV1">SSD Mobilenet V1
    </option>
    <option value="tiny_face_detector"
            [selected]="faceApiService.selectedFaceDetector === faceApiService.TINY_FACE_DETECTOR">Tiny Face Detector
    </option>
  </select>
  <!-- face_detector_selection_control -->
  <!-- fps_meter -->
  <h5>Time:</h5>
  <input disabled value="-" id="time" [(ngModel)]="faceApiService.time" type="text" class="bold">
  <br/>
  <h5>Estimated Fps:</h5>
  <input disabled value="-" id="fps" [(ngModel)]="faceApiService.fps" type="text" class="bold">
  <!-- fps_meter -->
  <hr/>
  <!-- ssd_mobilenetv1_controls -->
  <span id="ssd_mobilenetv1_controls"
        [ngStyle]="{'display': faceApiService.selectedFaceDetector === faceApiService.SSD_MOBILENETV1 && !faceApiService.loading?'block':'none'}">
            <h5>Min Confidence:</h5>
            <input disabled value="0.5" id="minConfidence" [(ngModel)]="faceApiService.minConfidence" type="text"
                   class="bold"> &nbsp;
            <button type="button" class="simpleButton" (click)="faceApiService.onDecreaseMinConfidence()">-</button> &nbsp;
            <button type="button" class="simpleButton" (click)="faceApiService.onIncreaseMinConfidence()">+</button>
         </span>
  <!-- ssd_mobilenetv1_controls -->
  <!-- tiny_face_detector_controls -->
  <span id="tiny_face_detector_controls"
        [ngStyle]="{'display': faceApiService.selectedFaceDetector === faceApiService.TINY_FACE_DETECTOR && !faceApiService.loading?'block':'none'}">
            <h5>Input Size</h5>
            <select id="inputSize" (change)="faceApiService.onInputSizeChanged($event)">
               <option value="" disabled selected>Input Size:</option>
               <option value="128">128 x 128</option>
               <option value="160">160 x 160</option>
               <option value="224">224 x 224</option>
               <option value="320">320 x 320</option>
               <option value="416">416 x 416</option>
               <option value="512">512 x 512</option>
               <option value="608">608 x 608</option>
            </select>
            <br/>
            <h5>Score Threshold:</h5>
            <input disabled value="0.5" id="scoreThreshold" [(ngModel)]="faceApiService.scoreThreshold" type="text"
                   class="bold"> &nbsp;
            <button type="button" class="simpleButton" (click)="faceApiService.onDecreaseScoreThreshold()">-</button> &nbsp;
            <button type="button" class="simpleButton" (click)="faceApiService.onIncreaseScoreThreshold()">+</button>
         </span>
  <!-- tiny_face_detector_controls -->
  <span *ngIf="showBoxes">
  <h5>Hide Bounding Boxes</h5>
  <input type="checkbox" [(ngModel)]="faceApiService.withoutBoxes"/>
  </span>
</div>
